import { Field } from 'react-final-form';

import { Select } from '@change/ds-forms';

import { useI18n } from '@change-corgi/core/react/i18n';

import { useFormI18n } from 'src/app/shared/form/hooks';

import type { FormValues, ReportType } from '../../shared/types';

import { useSubSubCategoryField } from './hooks/useSubSubCategoryField';

type Props = Readonly<{
	type: ReportType;
}>;

export const SubSubCategoryField: React.FC<Props> = ({ type }) => {
	const { translate } = useI18n();
	const { getErrorMessage } = useFormI18n();

	const {
		data: { subSubCategories },
		actions: { getLabel },
	} = useSubSubCategoryField({ type });

	if (subSubCategories.length === 0) return null;

	const subSubCategoryItems = [
		{ id: '', name: '', label: translate('corgi.policy_abuse.generic.sub_sub_category.prompt') },
		...subSubCategories.map((subSubCategory) => ({
			id: subSubCategory,
			name: subSubCategory,
			label: getLabel(subSubCategory),
		})),
	];

	return (
		<div>
			<Field<FormValues['subSubCategory']> name="subSubCategory">
				{({ input, meta }) => (
					<Select
						className="[&_button_span]:text-typography-weak"
						name={input.name}
						selectedKey={input.value}
						onSelectionChange={input.onChange}
						// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
						errorMessage={meta.touched && getErrorMessage(meta.error)}
						data-testid="reportAbuse-subSubCategory-select"
						data-qa="reportAbuse-subSubCategory-select"
						label={translate('corgi.policy_abuse.generic.sub_sub_category.label')}
						items={subSubCategoryItems}
						isInvalid={meta.touched && !!meta.error}
					/>
				)}
			</Field>
		</div>
	);
};
